import { createSlice } from "@reduxjs/toolkit";
import { sortDate } from "../../util/sort";

const initialState = {
  loadStorage: false,
  storage: [],
  };

const storageSlice = createSlice({
  name: "storage",
  initialState,
  reducers: {
    getAllStorage(state, action) {
      state.loadStorage = false;
      state.storage = action.payload;
      state.loadStorage = true;
    },
    // getAllAchiveStatus(state, action) {
    //   state.loadArchive = false;
    //   state.archive = action.payload;
    //   state.loadArchive = true;
    // },
    // getStatus(state, action) {
    //   state.loadStatus = false;
    //   state.chart = action.payload;
    //   state.loadStatus = true;
    // },
    loadStorage(state, action) {
      state.loadStorage = action.payload;
    },
  },
});

export default storageSlice.reducer;
export const { getAllStorage, loadStorage} = storageSlice.actions;
